import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class FakulteListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "FakulteListe";
    super(baseUrl);
  }


  getFakulteListe( fakulteKodu?: number){
    return this.get("", { params: { fakulteKodu: fakulteKodu } })

  }

}


export default new FakulteListeAPI();
class FakulteListeListeRequest {
  public fakulteKodu?: number;

 
  constructor(fakulteKodu?: number) {
   
      this.fakulteKodu = fakulteKodu;

      
  }
}
export { FakulteListeListeRequest };